/**
 * Liberacao de funcionalidade — rotulos e texto de confirmacao.
 *
 * O agrupamento por modulo (groupByModule, toggleModule...) e do
 * feature-module-picker e mora com ele em components/default/featureModules.js.
 */
import { groupByModule } from '../../components/default/featureModules.js';

/** Rotulos na ordem das opcoes; valor que a lista nao conhece e ignorado. */
export const labelsOf = (options, selected) => {
  const ordered = [];
  groupByModule(options).forEach((group) => {
    group.features.forEach((feature) => {
      if (selected.indexOf(feature.value) !== -1) ordered.push(feature.label);
    });
  });
  return ordered;
};

const MAX_NAMES_SHOWN = 5;

/**
 * Texto de confirmacao da liberacao, com o TAMANHO real: uma liberacao ativa
 * funcionalidades x empresas, e o "Selecionar todas" por modulo faz esse
 * produto crescer rapido com poucos cliques — sem o numero, a confirmacao
 * parece pequena quando nao e.
 *
 * Lista de nomes truncada em 5 para o dialogo continuar legivel; a ordem
 * recebida e preservada.
 */
export const releaseSummary = (names, companyCount, endsAt) => {
  const list = names || [];
  const featureCount = list.length;
  const shown = list.length > MAX_NAMES_SHOWN ? list.slice(0, MAX_NAMES_SHOWN) : list;
  const extra = list.length > MAX_NAMES_SHOWN ? list.length - MAX_NAMES_SHOWN : 0;
  const namesText = shown.join(', ') + (extra > 0 ? ' e mais ' + extra : '');
  const activations = featureCount * companyCount;

  return namesText + ' — ' + featureCount + ' funcionalidade(s) × ' + companyCount +
    ' empresa(s) = ' + activations.toLocaleString('pt-BR') + ' ativações, até ' +
    endsAt + ', com desligamento automático nessa data.';
};



// WEBPACK FOOTER //
// ./src/vue/pages/restricted/featureWindow/featureModules.js